$.fn.fcmqMap = function() {
  let self = this
  var iframe = self.find('.fcmq-map__iframe');
  var target = self.find('.fcmq-map__target');

  iframe.css('pointerEvents', 'none');

  target.click(function() {
    iframe.css('pointer-events', 'all');
    target.css('display', 'none');
  })

  iframe.mouseleave(function() {
    iframe.css('pointer-events', 'none');
    target.css('display', 'block');
  })

  return function() {
    return self
  }()
};
